import { render } from "./DriverReturnsReport.vue?vue&type=template&id=72b0eacb&scoped=true&ts=true"
import script from "./DriverReturnsReport.vue?vue&type=script&lang=ts"
export * from "./DriverReturnsReport.vue?vue&type=script&lang=ts"

import "./DriverReturnsReport.vue?vue&type=style&index=0&id=72b0eacb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b0eacb"]])

export default __exports__